module.exports = __webpack_public_path__ + "img/ic_company-logo_08.3121f0cf.svg";